import { lazy } from "react";

import { brandAdminPath } from "../../constants";
import { SCREEN_IDS } from "../../system/global-enums";

import MarketingSales from "../shared-screens/views/marketingSales/marketingSales";
import CampaignMetrics from "../shared-screens/views/campaignMetrics/campaignMetrics";

import Group from "../shared-screens/views/brandGroups";
import UserProfile from "../shared-screens/views/userProfile/userProfile";
import BrandProfile from "../shared-screens/views/brandProfile/brandProfile";
import ThemeSettings from "../shared-screens/views/themeSettings/themeSettings";
import UserPermissions from "../shared-screens/views/userPermissions/userPermissions";
import BrandPerformance from "../shared-screens/views/brandPerformance/brandPerformance";
import ConsumerResponses from "../shared-screens/views/consumerResponses/consumerResponses";
import ArchivedQuestions from "../shared-screens/views/archivedQuestions/archivedQuestions";
import IndividualStoreProfile from "../shared-screens/views/individualStoreProfile/individualStoreProfile";
import IndividualGroupProfile from "../shared-screens/views/individualGroupProfile/individualGroupProfile";
import IndividualStorePerformance from "../shared-screens/views/individualStorePerformance/individualStorePerformance";
import IndividualGroupPerformance from "../shared-screens/views/individualGroupPerformance/individualGroupPerformance";

const Stores = lazy(() => import("./../admin-screens/views/stores/stores"));

const BrandRoutes = [
  {
    path: brandAdminPath.STORES,
    name: "stores",
    screenId: SCREEN_IDS.BRANDS,
    component: Stores,
    displayName: "Brands",
    breadcrumb: "Brands",
  },
  {
    path: brandAdminPath.BRAND_MARKETING_SALES,
    name: "marketing-sales",
    screenId: SCREEN_IDS.BRANDS,
    component: MarketingSales,
    displayName: "Marketing Sales",
    breadcrumb: "Marketing Sales",
  },
  {
    path: brandAdminPath.BRAND_CAMPAIGN_METRICS,
    name: "campaign-metrics",
    screenId: SCREEN_IDS.BRANDS,
    component: CampaignMetrics,
    displayName: "Campaign Metrics",
    breadcrumb: "Campaign Metrics",
  },
  {
    path: brandAdminPath.BRAND_THEME_SETTINGS,
    name: "theme-settings",
    screenId: SCREEN_IDS.BRANDS,
    component: ThemeSettings,
    displayName: "Theme Settings",
    breadcrumb: "Brand Theme Settings",
  },
  {
    path: brandAdminPath.BRAND_PROFILE,
    name: "brand-restaurants",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandProfile,
    displayName: "Brand Stores",
    breadcrumb: "Brand Profile",
  },
  {
    path: brandAdminPath.BRAND_PERFORMANCE,
    name: "brand-performance",
    screenId: SCREEN_IDS.BRANDS,
    component: BrandPerformance,
    displayName: "Brand Performance",
    breadcrumb: "Brand Performance",
  },
  // Consumer Responses
  {
    path: brandAdminPath.CONSUMER_RESPONSES_BY_BRAND_PROFILE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: brandAdminPath.CONSUMER_RESPONSES_BY_GROUP,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: brandAdminPath.CONSUMER_RESPONSES_BY_PERFORMANCE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  // Individual Performance
  {
    path: brandAdminPath.RESTAURANT_PERFORMANCE_BY_BRAND_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: brandAdminPath.RESTAURANT_PERFORMANCE_BY_GROUP,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: brandAdminPath.RESTAURANT_PERFORMANCE_BY_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  // Individual Store Profile
  {
    path: brandAdminPath.RESTAURANT_PROFILE_BY_BRAND_PROFILE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: brandAdminPath.RESTAURANT_PROFILE_BY_GROUP,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: brandAdminPath.RESTAURANT_PROFILE_BY_PERFORMANCE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  // Individual Group Performance
  {
    path: brandAdminPath.GROUP_PERFORMANCE_BY_BRAND_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupPerformance,
    displayName: "Group Performance",
    breadcrumb: "Group Performance",
  },
  {
    path: brandAdminPath.GROUP_PERFORMANCE_BY_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupPerformance,
    displayName: "Group Performance",
    breadcrumb: "Group Performance",
  },
  // Individual Group Profile
  {
    path: brandAdminPath.GROUP_PROFILE_BY_BRAND_PROFILE,
    name: "profile",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupProfile,
    displayName: "Group Profile",
    breadcrumb: "Group Profile",
  },
  {
    path: brandAdminPath.GROUP_PROFILE_BY_PERFORMANCE,
    name: "profile",
    screenId: SCREEN_IDS.GROUP,
    component: IndividualGroupProfile,
    displayName: "Group Profile",
    breadcrumb: "Group Profile",
  },
  {
    path: brandAdminPath.USER_PROFILE,
    name: "userProfile",
    screenId: SCREEN_IDS.BRANDS,
    component: UserProfile,
    displayName: "User Profile",
    breadcrumb: "User Profile",
  },
  {
    path: brandAdminPath.BRAND_USER_PERMISSIONS,
    name: "user-permissions",
    screenId: SCREEN_IDS.BRANDS,
    component: UserPermissions,
    displayName: "User Permissions",
    breadcrumb: "Permissions",
  },
  {
    path: brandAdminPath.BRAND_GROUPS,
    name: "group",
    screenId: SCREEN_IDS.BRANDS,
    component: Group,
    displayName: "Groups",
    breadcrumb: "Brand Groups",
  },
  {
    path: brandAdminPath.BRAND_ARCHIVED_QUESTIONS,
    name: "archived-questions",
    screenId: SCREEN_IDS.BRANDS,
    component: ArchivedQuestions,
    displayName: "Archived Questions",
    breadcrumb: "Brand Archived Questions",
  },
];

export default BrandRoutes;
